module.exports = __webpack_public_path__ + "img/text5.72604642.png";